import { FC, PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { menuSx } from "./MenuWrapper.sx";

export const MenuWrapper:FC<PropsWithChildren> = ({children}) => {
  return <Box sx={menuSx}>
    {children}
  </Box>
}